import { lazy, Suspense, useEffect } from 'react';
import { Navigate, type RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';
import { useAuth } from '../../lib/auth';
import { clientType } from '../../lib/platform';

const PricingPage = lazy(() => import('./PricingPage'));

/**
 * A página de vendas mora no app próprio (apps/site, VITE_SITE_URL). No navegador, quem não está logado
 * e abre a raiz do app vai para ela; nos apps Android e Windows (e em dev, sem VITE_SITE_URL) vai para o login.
 */
const SITE_URL = ((import.meta.env.VITE_SITE_URL as string | undefined) ?? '').replace(/\/$/, '');
const goesToSite = clientType === 'web' && SITE_URL !== '' && SITE_URL !== window.location.origin;

function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <PageLoader />;
}

/** '/': quem já está logado vai direto para o app; os demais vão para o site de vendas ou para o login. */
function Home() {
  const { me } = useAuth();
  if (me) return <Navigate to="/inicio" replace />;
  if (goesToSite) return <ExternalRedirect to={`${SITE_URL}/`} />;
  return <Navigate to="/entrar" replace />;
}

/** '/precos': os planos ficam no site de vendas; sem ele (dev e apps), a página de preços do app. */
function Pricing() {
  if (goesToSite) return <ExternalRedirect to={`${SITE_URL}/#planos`} />;
  return (
    <Suspense fallback={<PageLoader />}>
      <PricingPage />
    </Suspense>
  );
}

/** Rotas públicas de marketing (raiz e preços). */
export const publicRoutes: RouteObject[] = [
  { index: true, element: <Home /> },
  { path: 'precos', element: <Pricing /> },
];
